
function initializeHero() {
  // Set whether to use scroll element or window to calculate scroll position. True sets the
  // scroll element to the background image of the hero, false sets it to the window.
  const useScrollElement = true
  // Set offset from the bottom in pixel, at which overlay should be maxed out
  const overlayOffset = 150

  // Get the hero element. This is where the css variable for the overlay lies on.
  const hero = document.querySelector(".hero--bg")

  // Exit function if hero element does not exist
  if (!hero) {
    return
  }

  // Scoll element. This is the element which the percentage of the scroll is calculated from.
  const scrollElement = document.querySelector(".hero--bg .hero__background")
  // Get the background image of the hero
  const backgroundImage = scrollElement.querySelector(".hero__background img");

  /**
   * Set the initial value for the overlay and add the event listener
   */
  function init() {
    // Only run if hero element exists
    if (hero && scrollElement) {
      // Set the initial scroll position
      setScrollPosition()
      // Add event listener for scroll event
      window.addEventListener("scroll", setScrollPosition)
    }
  }

  function setScrollPosition() {
    // Get the scroll position
    const scrollPosition = getScrollPosition().toFixed(2)
    // Make the background image transparent if the scroll position is outside of the hero
    backgroundImage.style.setProperty("opacity", scrollPosition < 1 ? 1 : 0);
    // Set the overlay opacity
    updateOpacity(scrollPosition)
  }

  function getScrollPosition() {
    // Get the current scroll position
    const scrollPosition = window.scrollY
    // Get the height of the scroll element
    let scrollElementHeight = useScrollElement
      ? scrollElement.offsetHeight
      : window.innerHeight
    // Subtract the offset from the scroll element height
    scrollElementHeight -= overlayOffset
    // Calculate the percentage of the scroll position
    const scrollPercentage = scrollPosition / scrollElementHeight
    // Return the percentage
    return scrollPercentage
  }

  function updateOpacity(opacity) {
    // Make sure opacity is between 0 and 1
    if (opacity > 1) {
      opacity = 1
    }
    // Set the opacity
    hero.style.setProperty("--overlay-opacity", opacity);
  }

  init()
}

export default initializeHero
